'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ThemeDetailsResponse from 'ecosystem-marketplace-core/records/ThemeDetailsResponse';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import ThemeDemoModal from './ThemeDemoModal';
import ThemeDetailsUsageTrackerContext from '../../context/ThemeDetailsUsageTrackerContext';

const ThemeDemoButton = (_ref) => {
  let {
    exampleUrl,
    name,
    providerName,
    section,
    themeDetails,
    themeScopes
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["exampleUrl", "name", "providerName", "section", "themeDetails", "themeScopes"]);

  const [modalOpen, setModalOpen] = useState(false);
  const {
    trackInteraction
  } = useContext(ThemeDetailsUsageTrackerContext);
  const onClick = useCallback(() => trackInteraction('click install button', {
    section
  }), [section, trackInteraction]);
  const handleClick = useCallback(evt => {
    setModalOpen(true);

    if (onClick) {
      onClick(evt);
    }
  }, [onClick]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
      "data-hs-analytics-id": getThemeEventSelectorId('PREVIEW'),
      onClick: handleClick,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.demoButton"
      })
    })), modalOpen && /*#__PURE__*/_jsx(ThemeDemoModal, {
      exampleUrl: exampleUrl,
      name: name,
      onClose: () => {
        setModalOpen(false);
      },
      providerName: providerName,
      themeDetails: themeDetails,
      themeScopes: themeScopes
    })]
  });
};

ThemeDemoButton.propTypes = {
  exampleUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
  section: PropTypes.string,
  themeDetails: PropTypes.instanceOf(ThemeDetailsResponse).isRequired,
  themeScopes: PropTypes.arrayOf(PropTypes.string)
};
export default ThemeDemoButton;